var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeovimLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1836 41.65L56.3836 89.6V190.858L21.3253 155.875V44.5333L24.1836 41.65ZM24.7503 35.725L17.5586 42.9833V157.433L60.1586 199.942V88.4417L24.7503 35.725ZM182.15 43.3917L138.967 0V111.092L175.092 165.417L182.442 157.442L182.15 43.3917ZM60.1253 0.00833333L170.875 169.008L139.884 200L29.0753 31.375L60.1253 0.00833333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeovimLogo);
export default __webpack_public_path__ + "static/media/neovim-logo.0c218075d54095335dd2bba2279ca5db.svg";
export { ForwardRef as ReactComponent };